import React from "react";
import { Radio, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import clicked from '../../assets/images/clicked.png'
import unClicked from '../../assets/images/unClicked.png'


const CustomFormControlLabel = styled(FormControlLabel)(({ theme, checked }) => ({
  margin: 0,
  borderRadius: "9999px",
  padding: "8px 16px",
  cursor: "pointer",
  transition: "all 0.2s",
  backgroundColor: checked ? "#380563" : "#f3f4f6",
  color: checked ? "#fff" : "#000",
  width: '100%',       
  height: '100%',     
  display: 'flex',    
  alignItems: 'center',
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    fontWeight: 500,
  },
}));



const CustomRadio = styled(Radio)(({ theme }) => ({
  padding: 0,
  marginRight: 8,
  "& .MuiSvgIcon-root": {
    width: 16,
    height: 16,
  },
  "&.Mui-checked": {
    color: "#fff",
  },
}));

const RadioButton = ({ label, name, value, checked, onChange }) => {
  return (
    <CustomFormControlLabel
      control={
        <CustomRadio
          checked={checked}
          onChange={onChange}
          value={value}
          name={name}
          icon={<img src={unClicked} alt="unclicked icon" width={20} height={20} />}
          checkedIcon={<img src={clicked} alt="clicked icon" width={20} height={20} />}

        />
      }
      label={label}
      checked={checked}
    />
  );
};

export default RadioButton;
